import SwiperNewsSlider from '../../components/swiper/news-slider.vue';
import NewsSwiper from '../../views/news/NewsSwiper.vue';

// NEWS一覧
window.Vue.component('swiper-news-slider', SwiperNewsSlider);
window.Vue.component('news-swiper', NewsSwiper);
